<template>
  <VModal :showing="showing" container-classes="max-w-200" @update:showing="cancel" @esc="cancel">
    <template #header>
      <h2 class="text-lg m-0">Choose the source of your {{ fileType }} file</h2>
      <div class="text-sm text-gray-600 font-normal capitalize">Create {{ fileType }} Slide</div>
    </template>
    <template #default>
      <VMessage :show="!!error" banner-type="danger" @dismiss="error = null">
        <div data-testid="file-upload-error">Could not upload {{ fileType }}: {{ error }}</div>
      </VMessage>
      <slot name="message" />
      <EditorLocalOrServerChoice
        class="text-gray-700"
        :company-id="companyId"
        :folder-id="folderId"
        :file-type="fileType"
        :mime-type="mimeType"
        :max-resolution="maxResolution"
        @choose-file="$emit('choose-file', $event)"
        @goto:shelf="$emit('goto:shelf')"
        @error="error = $event"
      />
    </template>
  </VModal>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import { ref } from 'vue'

defineProps({
  showing: {
    type: Boolean,
    required: true,
  },
  companyId: {
    type: [Number, Object] as PropType<number | null>,
    required: true,
  },
  folderId: {
    type: [Number, Object] as PropType<number | null>,
    default: null,
  },
  fileType: {
    type: String,
    required: true,
  },
  mimeType: {
    type: String,
    required: true,
  },
  maxResolution: {
    type: [Array, Object] as PropType<[number, number] | null>,
    default: null,
  },
})

const emit = defineEmits(['close', 'choose-file', 'goto:shelf'])

const error = ref<string | null>(null)

function cancel() {
  emit('close')
}
</script>
